// Canonical EPD Nigeria brand mark — the approved hero-page logo icon (single source of truth).
// Dark rounded square + connected-node/data glyph. Do not substitute the legacy green leaf.
export function BrandMark({ size = 32, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" aria-label="EPD Nigeria" className={className}>
      <rect x="1" y="1" width="30" height="30" rx="6" fill="#0f172a" />
      <circle cx="10" cy="10" r="2.6" fill="#10B981" />
      <circle cx="22" cy="10" r="2.6" fill="#64748B" />
      <circle cx="16" cy="22" r="2.6" fill="#E2E8F0" />
      <path d="M10 10 L22 10 L16 22 Z" stroke="#10B981" strokeWidth="1.4" opacity="0.75" fill="none" />
    </svg>
  );
}
